/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      jQuery(document).keydown(function(e) {
          var url = false;
          if (e.which == 37) {  // Left arrow key code
              url = jQuery('.main-buttons .prev a').attr('href');
          }
          else if (e.which == 39) {  // Right arrow key code
              url = jQuery('.main-buttons .next a').attr('href');
          }
          if (url) {
              window.location = url;
          }
      });

      $('.answerChoices').on('click','.wrongChoice',function () {
        $(this).parent().find('.wrongChoice').css('border-color', '#d9d9d9');
        $(this).css('border-color', 'red');
      });
      $('.answerChoices').on('click','.wrongChoice a',function () {
        $(this).parent().find('.wrongChoice a').css('color', 'red');
        $(this).css('color', 'red');
      });

      $('.answerChoices').on('click','.rightChoice',function () {
        $(this).parent().find('.rightChoice').css('border-color', '#d9d9d9');
        $(this).css('border-color', '#5cb85c');
      });
      $('.answerChoices').on('click','.rightChoice a',function () {
        $(this).parent().find('.rightChoice a').css('color', 'red');
        $(this).css('color', '#5cb85c');
      });


      //FRENCH
      $('.answerChoices').on('click','.fauxChoice',function () {
        $(this).parent().find('.fauxChoice').css('border-color', '#d9d9d9');
        $(this).css('border-color', 'red');
      });
      $('.answerChoices').on('click','.fauxChoice a',function () {
        $(this).parent().find('.fauxChoice a').css('color', 'red');
        $(this).css('color', 'red');
      });

      $('.answerChoices').on('click','.droiteChoice',function () {
        $(this).parent().find('.droiteChoice').css('border-color', '#d9d9d9');
        $(this).css('border-color', '#5cb85c');
      });
      $('.answerChoices').on('click','.droiteChoice a',function () {
        $(this).parent().find('.droiteChoice a').css('color', 'red');
        $(this).css('color', '#5cb85c');
      });


      document.getElementById('droite').onclick = function() {
        var sounds = document.getElementsByTagName('audio');
        for(i=0; i<sounds.length; i++) sounds[i].pause();
      };
      document.getElementById('faux').onclick = function() {
        var sounds = document.getElementsByTagName('audio');
        for(i=0; i<sounds.length; i++) sounds[i].pause();
      };
      document.getElementById('right').onclick = function() {
        var sounds = document.getElementsByTagName('audio');
        for(i=0; i<sounds.length; i++) sounds[i].pause();
      };
      document.getElementById('wrong').onclick = function() {
        var sounds = document.getElementsByTagName('audio');
        for(i=0; i<sounds.length; i++) sounds[i].pause();
      };
      document.getElementById('closeBtn').onclick = function() {
        var sounds = document.getElementsByTagName('audio');
        for(i=0; i<sounds.length; i++) sounds[i].pause();
      };
      document.getElementById('navigate').onclick = function() {
        var sounds = document.getElementsByTagName('audio');
        for(i=0; i<sounds.length; i++) sounds[i].pause();
      };

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


})(jQuery); // Fully reference jQuery after this point.